import { useEffect } from "react";
import { useSiteSettings } from "../../hooks/useSiteSettings";
import "./AboutPage.css";

function updateMeta(title, description) {
  if (title) {
    document.title = title;
  }

  if (description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", description);
  }
}

function AboutPage({ onChooseLocation }) {
  const { settings, loading, error } = useSiteSettings();

  useEffect(() => {
    if (settings) {
      updateMeta(settings.about_meta_title, settings.about_meta_description);
    }
  }, [settings]);

  if (loading) {
    return <main className="section public-simple-page"><div className="container empty-state">Loading about Zayas Kitchen...</div></main>;
  }

  if (error || !settings?.about_page_enabled) {
    return (
      <main className="section public-simple-page">
        <div className="container-sm empty-state">
          <strong>That page could not be found.</strong>
          <span>Please head home or choose a location to browse the menu.</span>
        </div>
      </main>
    );
  }

  return (
    <main className="section public-about-page">
      <div className="container public-about-hero">
        <div>
          <p className="eyebrow">{settings.about_eyebrow}</p>
          <h1>{settings.about_title}</h1>
          <p className="public-page-intro">{settings.about_intro}</p>
        </div>
        {settings.about_image ? (
          <img alt={settings.about_title} src={settings.about_image} />
        ) : null}
      </div>

      <section className="section-sm">
        <div className="container public-about-grid">
          <article className="card public-about-story">
            <div className="card-body">
              <p>{settings.about_story || settings.tagline}</p>
            </div>
          </article>

          {settings.about_secondary_title || settings.about_secondary_text || settings.about_secondary_image ? (
            <article className="card public-about-story">
              {settings.about_secondary_image ? (
                <img alt={settings.about_secondary_title || "Zayas Kitchen"} src={settings.about_secondary_image} />
              ) : null}
              <div className="card-body">
                {settings.about_secondary_title ? <h2>{settings.about_secondary_title}</h2> : null}
                {settings.about_secondary_text ? <p>{settings.about_secondary_text}</p> : null}
              </div>
            </article>
          ) : null}
        </div>
      </section>

      {settings.about_cta_title || settings.about_cta_text ? (
        <section className="section public-final-cta">
          <div className="container public-final-cta-inner">
            {settings.about_cta_title ? <h2>{settings.about_cta_title}</h2> : null}
            {settings.about_cta_text ? <p className="muted-text">{settings.about_cta_text}</p> : null}
            <button className="btn btn-primary btn-lg" onClick={onChooseLocation} type="button">
              {settings.about_cta_label || "View the Menu"}
            </button>
          </div>
        </section>
      ) : null}
    </main>
  );
}

export default AboutPage;